'use client'

export function PWAProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>
}

// バッジ更新用のヘルパー関数
export function updateAppBadge(count: number) {
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'SET_BADGE',
      count,
    })
  }
}
